<template>
  <div class="grid grid-cols-6">
    <div class="col-span-6 md:col-start-2 md:col-span-4 bg-white overflow-hidden shadow rounded-lg">
      <div class="px-4 py-5 sm:p-6">
        <div class="pb-4">
          <h3 class="text-3xl">Welcome {{ auth.user.first_name }}</h3>
          <p class="mt-2 leading-normal">We would like to take this moment to guide you through the setup of your first account. You can choose to open your account as a <b>business</b> account or an <b>individual</b> account with your mobile number {{ auth.user.mobile }}.</p>

          <p class="leading-normal mt-6">Only a business account can add multiple shop accounts, however there is an approval process for each new business account.</p>
          <p class="leading-normal"><b>Tax invoice issued for individual customers will not be claimable for GST from MIRA.</b></p>
          <p class="leading-normal">An individual account is limited for personal use only.</p>
        </div>

        <div class="bg-gray-100 sm:rounded-t-lg grid grid-cols-1 lg:grid-cols-2">
          <div class="p-3">
            <h3 class="text-lg leading-6 font-medium text-gray-900">
              Choose your account type
            </h3>

            <div class="mt-5">
              <select-input v-model="form.type" class="w-full">
                <option :value="null" disabled>Choose</option>
                <option value="business">Business</option>
                <option value="individual">Individual</option>
              </select-input>
            </div>
          </div>
          <div class="p-3">
            <h3 class="text-lg leading-6 font-medium text-gray-900">
              <span v-if="form.type === 'business'">Business </span>
              <span v-else>Your </span>
              location
            </h3>

          </div>

          <div class="py-1 px-3">
            <select-input v-model="form.atoll_id" :errors="$page.props.errors.atoll_id" class="w-full" label="Atoll" required>
              <option :value="null" />
              <option v-for="atoll in atoll_list" :value="atoll.id" :key="atoll.id">{{ atoll.name }}</option>
            </select-input>
          </div>

          <div class="py-1 px-3">
            <select-input  v-model="form.island_id" :errors="$page.props.errors.island_id" class="w-full" label="Island" required>
              <option :value="null" />
              <option v-if="form.atoll_id && form.atoll_id === irow.atoll_id" v-for="irow in island_list" :value="irow.id" :key="irow.id">{{ irow.name }}</option>
            </select-input>
          </div>

          <div class="py-1 px-3 mt-2" v-if="form.type === 'business'">
            <text-input v-model="form.name"  :errors="$page.props.errors.name" class="mt-2 lg:mt-0" label="Business Name" />
          </div>

          <div class="py-1 px-3 mt-2" v-if="form.type === 'individual'">
            <text-input v-model="form.name"  :errors="$page.props.errors.name" class="mt-2 lg:mt-0" label="Your Address/House Name" />
          </div>

          <div class="py-1 px-3 mt-2" v-if="form.type === 'business'">
            <select-input v-model="form.business_type" class="w-full" label="Business Type" :errors="$page.props.errors.business_type">
              <option :value="null" />
              <option v-for="(btype, bkey) in business_types" :value="bkey" :key="bkey">{{ btype }}</option>
            </select-input>
          </div>

          <div class="py-1 px-3 mt-2 lg:col-span-2" v-if="form.type === 'business'">
            <div class="grid grid-cols-1 lg:grid-cols-2">
              <select-input v-model="form.none_tax" label="GST Registered?" class="lg:mr-3">
                <option :value="0">Yes</option>
                <option :value="1">No</option>
              </select-input>
              <text-input v-model="form.tin_number" :disabled="form.none_tax === 1" :errors="$page.props.errors.tin_number" class="mt-2 lg:mt-0 lg:ml-3" label="GST TIN Number" />
            </div>
          </div>
        </div>

        <div class="bg-gray-100 rounded-b sm:rounded-b-lg p-3">
          <loading-button :loading="sending" class="btn-primary" type="submit" :disabled="!canSubmitForm" @click="submitAccountForRegistration">Submit</loading-button>
        </div>



      </div>
    </div>

    <!-- confirm modal -->
    <modal :show="show_confirm" @closeModal="show_confirm = false">
      <div class="px-4 py-5 sm:p-6">
        <h3 class="text-lg leading-6 font-medium text-gray-900">
          Please confirm
        </h3>
        <div class="mt-2 max-w-xl text-sm leading-5 text-gray-500">
          <p>
            You are about to proceed as a walk-in customer (individual) account. Invoices issued will not be claimable for GST from MIRA.
          </p>
        </div>
        <div class="mt-5 flex justify-between">

          <loading-button @click="cancelConfirm" class="btn-gray">
            Cancel
          </loading-button>

          <loading-button @click="confirmSubmit" class="btn-primary">
            Confirm & Proceed
          </loading-button>
        </div>
      </div>
    </modal>
    <!-- confirmed -->
  </div>

</template>

<script>
  import BasicLayout from '@/Shared/Customers/BasicLayout'
  import SelectInput from '@/Shared/SelectInput'
  import TextInput from '@/Shared/TextInput'
  import LoadingButton from '@/Shared/LoadingButton'
  import Modal from '@/Shared/Modal'

  export default {
    metaInfo: { title: 'Onboarding Customer' },
    layout: BasicLayout,
    components: { SelectInput, TextInput, LoadingButton, Modal },
    props: {
      auth: Object,
      business_types: Object,
      locations: Object,
      atoll_list: Array,
      island_list: Array,
    },
    data() {
      return {
        sending: false,
        show_confirm: false,
        individual_customer_confirmed: false,
        form: {
          type: null,
          name: null,
          location: null,
          none_tax: 0,
          tin_number: null,
          business_type: null,
          atoll_id: null,
          island_id: null
        }
      }
    },

    watch: {
      'form.none_tax': function(val) {
        if(val == 0) {
          this.form.tin_number = null;
        }
      },
      'form.type': function(val) {
        if(val === 'individual') {
          this.form.business_type = null;
          this.form.tin_number = null;
          this.form.none_tax = 0;
        } else {
          this.form.none_tax = 1;
        }
      },
      'form.atoll_id': function() {
        this.form.island_id = null
      }
    },

    computed: {
      canSubmitForm() {
        let form = this.form;
        if(form.type && form.name && form.atoll_id) {
          if(!form.island_id) {
            return false;
          }

          if(form.type === 'business') {
            if(form.business_type) {
              if(form.none_tax === 0) {
                if(form.tin_number) {
                  return true
                }
                return false
              } else {
                return true
              }
            }
            return false;
          } else {
            return true;
          }
        }
        return false;
      }
    },

    methods: {
      confirmSubmit() {
        this.individual_customer_confirmed = true;
        this.show_confirm = false;
        this.submitAccountForRegistration();
      },
      cancelConfirm() {
        this.individual_customer_confirmed = false;
        this.show_confirm = false;
      },
      submitAccountForRegistration() {

        if(this.form.type !== 'business' && this.individual_customer_confirmed !== true) {
          this.show_confirm = true;
          return
        }

        this.sending = true
        this.$inertia.post(this.route('customer.onboarding.store'), this.form)
          .then(() => this.sending = false)
      }
    }
  }
</script>
